import { collection, getDocs, getFirestore, query } from "@firebase/firestore";
import { firebaseApp } from "../../../firebase/firebaseClient";
import { convertSnapToPOJO } from "../../../utils/objects";
import useSWR from "swr";

const fetcher = async (userId) => {
  const firestore = getFirestore(firebaseApp);
  const purchasedQuery = query(
    collection(firestore, "guide_purchases", "users", userId)
  );
  const purchasedSnap = await getDocs(purchasedQuery);
  const purchasedGuides = purchasedSnap.docs.map((doc) =>
    convertSnapToPOJO(doc)
  );
  const purchasedEnhance = purchasedGuides.some((obj) => obj.key === "enhance");
  return { isPurchased: purchasedEnhance };
};

const usePurchasedEnhance = (userId) => {
  const { data, error } = useSWR(userId ? `/${userId}` : null, fetcher);

  return {
    purchasedEnhance: data,
    isLoading: !error && !data,
    isError: error,
  };
};

export default usePurchasedEnhance;
